export const QUERY_CLIENT_RETRY_ATTEMPS = 2;
export const QUERY_CLIENT_STALE_TIME = 5 * 60 * 1000; /* 5 minutos */
import asegurameLogo from '../assets/images/Logos/AsegurameLogoMovil.svg';

export const IMAGEN_SEGUROS_ASEGURAME = {
  asegurameMedico:
    'https://aseguramecr.s3.us-east-2.amazonaws.com/Imagenes/Productos/EnfermedadesGraves/Icono-Small.webp',
  asegurameVehiculo:
    'https://aseguramecr.s3.us-east-2.amazonaws.com/Imagenes/Productos/AutoexpedibleAuto/Icono-Small.webp',
  asegurameViaje:
    'https://aseguramecr.s3.us-east-2.amazonaws.com/Imagenes/Productos/ViajeSalida/Icono-Small.webp',
  asegurameOncologicoPlus:
    'https://aseguramecr.s3.us-east-2.amazonaws.com/Imagenes/Productos/Oncologico/Icono-Small.svg',
  aseguramePlenisalud:
    'https://aseguramecr.s3.us-east-2.amazonaws.com/Imagenes/Productos/Plenisalud/Icono-Big.svg',
};

export const SEGUROS_ASEGURAME = {
  'SEG-DA': 'Seguro deducible vehiculo',
  'SEG-V': ' seguro viaje',
  'SEG-AEG': 'Seguro de enfermedades graves',
  'SEG-ONC': 'Seguro oncologico plus',
  'SEG-PLENI': 'Seguro plenisalud',
  'SEG-VID': 'Seguro vida plus',
};

export const SEGUROS_CATOLICA = {
  'SEG-PLENI-HILC': 'Seguro plenisalud',
};

export const LOGOS = {
  ASEGURAME: asegurameLogo,
  CATOLICA:
    'https://aseguramecr.s3.us-east-2.amazonaws.com/Imagenes/Logos/logo-hospital-catolica.svg',
};

export const NOMBRES_BY_PROYECT = {
  ASEGURAME: 'Asegurame',
  CATOLICA: 'Hospital Internacional La Católica',
};

export const DEFAULT_URL = {
  ASEGURAME: '/home',
  CATOLICA: '/cotizar-seguro-plenisalud?paso=seguro',
};
